import React from 'react'
import { Modal, Button } from '@arnsbogroup/react-voicearchive'
import Icon from 'components/Icon'

const AddWidgetModal = ({ show = false, available = [], widgets = [], onAdd, onClose }) => {
  const present = widgets.map((widget) => widget.widgetId)
  const addable = available.filter((entry) => !present.includes(entry.widgetId))

  return (
    <Modal
      show={show}
      title="Add widget"
      onClose={onClose}
      onOutsideClick={onClose}
      onSubmit={onClose}
    >
      {addable.length === 0 ? (
        <p className="py-2 text-sm text-gray-500">
          Every widget available to you is already on your dashboard. Remove one to free
          up space.
        </p>
      ) : (
        <ul className="-mx-2 max-h-96 list-none overflow-y-auto">
          {addable.map((entry) => (
            <li key={entry.widgetId}>
              <button
                type="button"
                className="flex w-full items-center gap-3 rounded px-2 py-3 text-left text-sm text-gray-700 transition hover:bg-gray-100 hover:text-primary"
                onClick={() => {
                  onAdd(entry)
                  onClose()
                }}
              >
                <Icon icon="plus" className="text-xs text-gray-400" />
                <span>{entry.label}</span>
              </button>
            </li>
          ))}
        </ul>
      )}

      {/* The Modal's own close cross is tabIndex={-1}, so this is the only
          keyboard-reachable way out besides Esc. */}
      <div className="mt-4 flex justify-end border-t pt-4">
        <Button variant="outline" size="sm" onClick={onClose}>
          Close
        </Button>
      </div>
    </Modal>
  )
}

export default AddWidgetModal
